
        require('./index.scss');
        'use strict';

var _user = require('model/service/user');

var _user2 = _interopRequireDefault(_user);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// import md5 from 'assets/util/kft-md5'
window.msgSend = false;

var addListener = false;

function verify(mobile, node) {
    var timer = null;
    var secretKey = 'd4c38977656e2356a6837e7b771bd408';
    var text = node.text();

    var popup = $('#verify .popup');
    var img = popup.find('.img img');
    var submit = popup.find('.submit');
    var imgInput = popup.find('.img input');
    var messageBtn = popup.find('.code #sendMsg');
    var msgCode = popup.find('.code input');

    var init = function init() {
        img.click(function () {
            return getImgCode();
        });
        popup.find('.close-icon').click(function () {
            $('#verify').hide();
            reset();
        });
        messageBtn.click(function () {
            var _this = this;

            if (imgInput.val() === '') {
                $('#img-test').show().delay(2000).fadeOut();
                return;
            }
            console.log(window.msgSend);
            if (window.msgSend === true) return;
            _user2['default'].sendMsg({
                mobile: mobile,
                type: 2,
                imgcode: imgInput.val(),
                channel: 12
            }).then(function (res) {
                console.log(res);
                if (res.code === 6) {
                    window.toast && window.toast(res.msg || '验证码错误', 2000);
                    getImgCode();
                } else if (res.code === 200 || res.code === 56) {
                    counter($(_this));
                } else {
                    window.toast && window.toast(res.msg || '短信发送失败', 2000);
                }
            });
        });

        submit.click(function () {
            if (!msgCode.val()) {
                $('#msg-test').show().delay(2000).fadeOut();
                return;
            }
            if (mobile) {
                $('#verify').hide();
                window.captcha = msgCode.val();
                if (node) {
                    node.click();
                    reset();
                }
            }
        });
    };
    var counter = function counter(node) {
        var t = 60;
        // node.removeClass('beforeGetMsgCode');
        node.text('60s');
        timer = setInterval(function () {
            --t;
            if (t <= 0) {
                clearInterval(timer);
                // node.add('beforeGetMsgCode');
                node.text('获取验证码');
                window.msgSend = false;
            } else {
                node.text(t + 's');
            }
        }, 1000);
    };
    var reset = function reset() {
        clearInterval(timer);
        window.msgSend = false;
        messageBtn.text('获取验证码');
        msgCode.val('');
        imgInput.val('');
    };

    if (!addListener) {
        init();
        addListener = true;
    }

    submit.text(text);

    var domain = 'focus-test';
    if (/(focus.*)\./.test(window.location.href)) {
        domain = /(focus.*)\./.exec(window.location.href)[1] || domain;
    }
    var getImgCode = function getImgCode() {
        var src = img.data('link').replace(/focus/, domain);
        img.attr('src', src + '?' + Math.random());
    };
    getImgCode();

    $('#verify').show();
}

function toast(msg, time) {
    if (!msg) return;
    if (!time) time = 3000;
    var mask = $('<div class="toast-mask"></div>');
    var content = $('<span class="toast"></span>');
    content.text(msg);
    mask.append(content);
    $('body').append(mask);
    mask.click(function () {
        mask.remove();
    });
    setTimeout(function () {
        mask.remove();
    }, time);
}

window.verify = verify;
window.toast = toast;;
    


// WEBPACK FOOTER //
// ./src/module/home-index/mobile-verify/index.js